import { render } from "./BaseIngredientsCatalog.vue?vue&type=template&id=4b87a116&scoped=true"
import script from "./BaseIngredientsCatalog.vue?vue&type=script&lang=js"
export * from "./BaseIngredientsCatalog.vue?vue&type=script&lang=js"

import "./BaseIngredientsCatalog.vue?vue&type=style&index=0&id=4b87a116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87a116"]])

export default __exports__